import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useCanjeModal } from '../context/CanjeModalContext';

const CanjeModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCanjeModal();

  const hasValidDate =
    data.date && data.date >= data.lastOperationDate && data.ratioOld >= 1;

  const step1Enabled = data.scriptureView && hasValidDate;

  const step2Enabled =
    !data.scriptureView &&
    !!data.targetSocietyId &&
    !!data.selectedHoldingClass &&
    !data.previewErrorKey &&
    data.previewParticipants.length > 0 &&
    data.selectedParticipantIds.length > 0;

  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <Modal.Footer className="bg-white">
      <button
        type="button"
        className="btn btn-secondary"
        onClick={actions.handleCloseModal}
      >
        {t('Cancel')}
      </button>
      <button
        type="button"
        className="btn btn-primary"
        disabled={data.isLoading || (!step1Enabled && !step2Enabled)}
        onClick={actions.handleSaveCanje}
      >
        {buttonText}
      </button>
    </Modal.Footer>
  );
};

export default CanjeModalFooter;
